import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  includeReturnLabelRuleName: {
    id: 'JnF5hv',
    defaultMessage: 'Include return label with every shipment',
    description: 'Name for the system automation rule that includes return labels with shipments',
  },
  loadAutomationRulesError: {
    id: '7S5QSH',
    defaultMessage: 'Failed to load automation rules',
    description: 'Error message shown when automation rules fail to load',
  },
  updateSuccessTitle: {
    id: 'e5T8mb',
    defaultMessage: 'Success',
    description: 'Title for successful automation rule update notification',
  },
  updateSuccessContent: {
    id: 'LNJqRg',
    defaultMessage: 'Automation rule updated successfully',
    description: 'Content for successful automation rule update notification',
  },
  updateFailedTitle: {
    id: 'YznT6q',
    defaultMessage: 'Update Failed',
    description: 'Title for failed automation rule update notification',
  },
  updateFailedError: {
    id: '2tp+UL',
    defaultMessage: 'Failed to update automation rule',
    description: 'Error message when automation rule update fails',
  },
  createSuccessTitle: {
    id: 'BTgBZs',
    defaultMessage: 'Success',
    description: 'Title for successful automation rule creation notification',
  },
  createSuccessContent: {
    id: 'O7xdPh',
    defaultMessage: 'Automation rule created successfully',
    description: 'Content for successful automation rule creation notification',
  },
  createFailedTitle: {
    id: 'fqFrZq',
    defaultMessage: 'Creation Failed',
    description: 'Title for failed automation rule creation notification',
  },
  createFailedError: {
    id: 'X2yH+N',
    defaultMessage: 'Failed to create automation rule',
    description: 'Error message when automation rule creation fails',
  },
});
